// extracted by mini-css-extract-plugin
export default {"text":"AiSetFakedoorModal__text--32x7Z","items":"AiSetFakedoorModal__items--1vvTx","item":"AiSetFakedoorModal__item--38YI5","closeIcon":"AiSetFakedoorModal__closeIcon--V0wrA"};